import { render, staticRenderFns } from "./AddAccessory.vue?vue&type=template&id=bf97b8d0&scoped=true&"
import script from "./AddAccessory.vue?vue&type=script&lang=js&"
export * from "./AddAccessory.vue?vue&type=script&lang=js&"
import style0 from "./AddAccessory.vue?vue&type=style&index=0&id=bf97b8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf97b8d0",
  null
  
)

export default component.exports